(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["h17-dealer-finder"] && !Shopify.designMode) return;
  try {
    
  if (!window.h17DealerFinderListenerBound) {
    window.h17DealerFinderListenerBound = true;

    document.addEventListener('submit', (event) => {
      const form = event.target.closest('[data-dealer-form]');
      if (!form) return;
      event.preventDefault();
      const root = form.closest('[data-h17-dealer-finder]');
      const input = form.querySelector('[name="postal_code"]');
      const validation = root.querySelector('[data-dealer-validation]');
      const loading = root.querySelector('[data-dealer-loading]');
      const empty = root.querySelector('[data-dealer-empty]');
      const error = root.querySelector('[data-dealer-error]');
      const results = root.querySelector('[data-dealer-results]');
      [loading, empty, error, results].forEach((el) => { el.hidden = true; });
      const valid = /^\d{5}$/.test(input.value.trim());
      validation.hidden = valid;
      input.setAttribute('aria-invalid', String(!valid));
      if (!valid) { input.focus(); return; }
      loading.hidden = false;
      window.setTimeout(() => {
        try {
          loading.hidden = true;
          if (root.dataset.demoMode === 'true' && results.children.length) results.hidden = false;
          else empty.hidden = false;
        } catch (_) {
          loading.hidden = true;
          error.hidden = false;
        }
      }, 350);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["h17-header"] && !Shopify.designMode) return;
  try {
    
  const h17MenuLayouts = new WeakMap();

  function initializeH17MenuLayout(root = document) {
    root.querySelectorAll('[data-h17-site-header]').forEach((header) => {
      if (h17MenuLayouts.has(header)) return;
      const section = header.closest('.h17-header-section');
      if (!section) return;
      let frame;
      const update = () => {
        const panels = header.querySelectorAll('.h17-nav-menu[open] > .h17-mega, .h17-mobile-nav[open] > .h17-mobile-nav__panel');
        const height = Math.max(0, ...Array.from(panels, (panel) => {
          const bounds = panel.getBoundingClientRect();
          return bounds.width ? bounds.height : 0;
        }));
        section.style.setProperty('--h17-open-menu-height', `${height}px`);
        previousScrollY = pageScrollY();
      };
      const schedule = () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(update);
      };
      const pageWrapper = document.querySelector('.page-wrapper');
      const pageScrollY = () => window.scrollY + (pageWrapper?.scrollTop || 0);
      let previousScrollY = pageScrollY();
      const closeOnScroll = () => {
        const menus = Array.from(header.querySelectorAll('details[open]'));
        if (!menus.length) return;
        const focusedMenu = menus.find((menu) => menu.contains(document.activeElement));
        menus.forEach((menu) => { menu.open = false; });
        focusedMenu?.querySelector(':scope > summary')?.focus({ preventScroll: true });
        schedule();
      };
      const onPageScroll = () => {
        const currentScrollY = pageScrollY();
        if (Math.abs(currentScrollY - previousScrollY) > 1) closeOnScroll();
        previousScrollY = currentScrollY;
      };
      const onWheel = (event) => {
        if (event.ctrlKey || Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;
        if (!(event.target instanceof Element) || event.target.closest('dialog[open], [role="dialog"]')) return;
        const panel = event.target.closest('.h17-mega, .h17-mobile-nav__panel');
        if (panel && header.contains(panel) && panel.scrollHeight > panel.clientHeight + 1) return;
        closeOnScroll();
      };
      const onPageKey = (event) => {
        if (!['PageDown', 'PageUp'].includes(event.key) || event.ctrlKey || event.metaKey || event.altKey) return;
        if (!(event.target instanceof Element) || event.target.closest('input, textarea, select, [contenteditable], dialog[open], [role="dialog"]')) return;
        const panel = event.target.closest('.h17-mega, .h17-mobile-nav__panel');
        if (panel && header.contains(panel) && panel.scrollHeight > panel.clientHeight + 1) return;
        closeOnScroll();
      };
      const observer = new ResizeObserver(schedule);
      header.querySelectorAll('.h17-mega, .h17-mobile-nav__panel').forEach((panel) => observer.observe(panel));
      header.addEventListener('toggle', schedule, true);
      window.addEventListener('resize', schedule);
      window.addEventListener('scroll', onPageScroll, { passive: true });
      pageWrapper?.addEventListener('scroll', onPageScroll, { passive: true });
      window.addEventListener('wheel', onWheel, { passive: true });
      window.addEventListener('keydown', onPageKey);
      h17MenuLayouts.set(header, () => {
        cancelAnimationFrame(frame);
        observer.disconnect();
        header.removeEventListener('toggle', schedule, true);
        window.removeEventListener('resize', schedule);
        window.removeEventListener('scroll', onPageScroll);
        pageWrapper?.removeEventListener('scroll', onPageScroll);
        window.removeEventListener('wheel', onWheel);
        window.removeEventListener('keydown', onPageKey);
        h17MenuLayouts.delete(header);
      });
      update();
    });
  }

  initializeH17MenuLayout();
  document.addEventListener('shopify:section:load', (event) => initializeH17MenuLayout(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-h17-site-header]').forEach((header) => h17MenuLayouts.get(header)?.());
  });

  document.addEventListener('click', (event) => {
    const mobileLink = event.target.closest('.h17-mobile-nav__panel a');
    if (mobileLink) {
      const mobileMenu = mobileLink.closest('.h17-mobile-nav');
      if (mobileMenu) mobileMenu.open = false;
    }

    if (!event.target.closest('.h17-site-header')) {
      document.querySelectorAll('.h17-site-header details[open]').forEach((menu) => {
        menu.open = false;
      });
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.h17-site-header details[open]').forEach((menu) => {
      menu.open = false;
      menu.querySelector('summary')?.focus();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
